import moment from 'moment';
import { DATETIME_FORMAT } from './Constants';

export type DateFormats = {
  full: string,
  relative: string
};

export default class DateTimeUtil {
  static DD_MM_YYYY_HH_MM_FORMAT = 'Do MMM YYYY, h:mm a';
  static MMM_D_YYYY_HH_MM_A_FORMAT = 'MMM DD, YYYY [at] h:mmA';
  static MMM_D_YYYY_HH_MM_FORMAT = 'MMM DD, YYYY h:mmA';

  /**
   *
   * Formats the given date in Date and time format, without seconds.
   * @param {Date} date
   */
  static toDateTime(date) {
    return moment(date).format(DateTimeUtil.DD_MM_YYYY_HH_MM_FORMAT);
  }

  /**
   * Returns the relative duration from now. Like momemnt ago, 2days ago..
   * @param {Date} date
   */
  static relativeFromNow(date) {
    return moment(date).fromNow();
  }

  static parseDate(input) {
    if (typeof input === 'string' && /^\d+$/.test(input)) {
      input = parseInt(input, 10);
    }

    const date = new Date(input);

    if (isNaN(date.valueOf())) {
      return null;
    }

    return date;
  }

  static getFormattedTime(repoItem: RepoItem): DateFormats {
    let formattedTime = repoItem.formattedTime;
    if (!formattedTime) {
      let _format = this.format(repoItem.getMtime());
      repoItem.formattedTime = _format;
    }
    return repoItem.formattedTime;
  }

  static format(millis: number, formatter: ?string = DATETIME_FORMAT): DateFormats {
    let full = '',
      relative = '',
      full_formated = '';
    moment.updateLocale('en', {
      relativeTime: {
        past: '%s ago',
        s: '1s',
        ss: '%ds',
        m: '1min',
        mm: '%dmin',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        w: '1w',
        ww: '%dw',
        M: '1mo',
        MM: '%dmo',
        y: '1y',
        yy: '%dy'
      }
    });

    if (millis && millis > 0) {
      const m = moment(millis);
      full = m.format(formatter);
      relative = m.fromNow();
      full_formated = m.format(DateTimeUtil.MMM_D_YYYY_HH_MM_FORMAT);
    }

    return {
      full,
      full_formated,
      relative
    };
  }

  static delta(millis: number) {
    const now = Date.now();
    return now - millis;
  }

  static checkDelta(millis: number, minDelta: number) {
    return DateTimeUtil.delta(millis) >= minDelta;
  }
}
